import styled from 'styled-components';
import {
  Breadcrumbs,
  EmptyStateBox,
  FlexColumn,
  Loading,
} from '@elementary/common-ui/components';
import { useNavigate, useParams } from 'react-router-dom';
import { RUNTIMES_BASE_PATH } from '../constants';
import useRuntime from '../hooks/useRuntime';
import RuntimeConfiguration from './RuntimeConfiguration';
import RuntimeDebugPlaceholder from './RuntimeDebugPlaceholder';
import RuntimeStatusSummary from './RuntimeStatusSummary';
import RuntimeTokens from './RuntimeTokens';
import RuntimeWarehouses from './RuntimeWarehouses';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 48px;
  padding-bottom: 32px;
`;

const RuntimeDetails = () => {
  const { runtimeId = '' } = useParams();
  const navigate = useNavigate();
  const { runtime, isLoading, isError } = useRuntime(runtimeId);

  const goToRuntimes = () => navigate(RUNTIMES_BASE_PATH);

  if (isLoading) {
    return <Loading />;
  }

  if (isError || !runtime) {
    return (
      <EmptyStateBox title="Runtime not found">
        <EmptyStateBox.ClickableText onClick={goToRuntimes}>
          Back to runtimes
        </EmptyStateBox.ClickableText>
      </EmptyStateBox>
    );
  }

  return (
    <Wrapper>
      <Breadcrumbs
        items={[
          'Account',
          {
            label: 'Runtimes',
            onClick: (e) => {
              e.preventDefault();
              goToRuntimes();
            },
          },
          runtime.name,
        ]}
        showTreeButton={false}
      />
      <RuntimeStatusSummary runtime={runtime} />
      <RuntimeWarehouses runtime={runtime} />
      <RuntimeTokens runtimeId={runtime.id} />
      <RuntimeConfiguration runtime={runtime} />
      <RuntimeDebugPlaceholder />
    </Wrapper>
  );
};

export default RuntimeDetails;
